import css from './Container.module.scss';
import classNames from 'classnames';

export default function Container({children}) {
  return (
    <div className={classNames(css.container, css.webContainer)}>{children}</div>
  );
}